module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_vm._v("About The Author")]), _vm._v(" "), _c('p', [_vm._v("T. Harrogate is an English-born woman. She was born in Harrogate, Yorkshire. She moved to Ireland when she was fourteen. She has lived in County Cork ever since. She is married to Joe for thirty-one years. The author works as a healthcare assistant in a maternity hospital in Cork. She writes stories as a hobby. This is her very first book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0